export default "__VITE_PUBLIC_ASSET__821150e1__"